import React, { useState, useEffect, useRef } from 'react';
import { Search, X, ChevronDown, SortAsc, SortDesc, Plus, AlertTriangle } from 'lucide-react';


// Import the JSON-based configuration
import appConfig, { ENDPOINT_KEYS } from './config/appConfig';


const DialogStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    padding: '0',
    margin: '0'
  },
  dialog: {
    backgroundColor: 'white',
    padding: '0px 20px 10px 20px',
    borderRadius: '8px',
    width: '400px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    gap: '0'
  },
  title: {
    fontSize: '18px',
    textAlign: 'center',
    margin: 0,
    padding: '10px 0',
    color: '#000'
      },
  button: {
    backgroundColor: '#FFFDD0',
    border: 'none',
    borderRadius: '4px',
    padding: '10px',
    width: '100%',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 500,
    color: 'black'
  }
};

const ManageLinksDialog = ({
  isOpen,
  onClose,
  corporateAccount,
  projectId,
  login_token,
  sourceRecordType,
  selectedSourceIds,
  sourceIdWithPrefix
}) => {
  const [links, setLinks] = useState([]);
  const [selectedLinks, setSelectedLinks] = useState(new Set());
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isAddLinkDialogOpen, setIsAddLinkDialogOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredLinks, setFilteredLinks] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // States for add link dialog
  const [searchResults, setSearchResults] = useState([]);
  const [availableLinkTypes, setAvailableLinkTypes] = useState([]);
  const [selectedLinkType, setSelectedLinkType] = useState('');
  const [selectedRecordType, setSelectedRecordType] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [isLoadingLinkTypes, setIsLoadingLinkTypes] = useState(false);
  const [selectedTargetIds, setSelectedTargetIds] = useState([]);
  const [recordTypes, setRecordTypes] = useState([]);
  const [isLoadingRecordTypes, setIsLoadingRecordTypes] = useState(false);

  // New permissions state
  const [permissions, setPermissions] = useState({
    canCreate: false,
    canDelete: false
  });

  // Delete confirmation dialog state
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);

  const searchQueryRef = useRef(null);

  const styles = {
    container: {
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
    },
table: {
  width: '100%',
  borderCollapse: 'collapse',
  marginTop: '0px',
  backgroundColor: '#fff',
  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  fontSize: '0.875rem',
  margin: '0',
},
    th: {
      backgroundColor: '#E5E4E2',
      color: '#0064e5',
      padding: '6px 12px',
      textAlign: 'left',
      borderBottom: '2px solid #ddd',
      fontSize: '0.875rem',
      lineHeight: '1',
      height: '32px',
      cursor: 'pointer',
      userSelect: 'none',
      position: 'relative'
    },
    thNonSortable: {
      backgroundColor: '#E5E4E2',
      color: '#0064e5',
      padding: '6px 12px',
      textAlign: 'left',
      borderBottom: '2px solid #ddd',
      fontSize: '0.875rem',
      lineHeight: '1',
      height: '32px'
    },
    td: {
      padding: '12px',
      borderBottom: '1px solid #ddd',
    },
    checkbox: {
      marginRight: '10px',
    },
    deleteButton: {
      backgroundColor: '#dc3545',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      padding: '6px 12px',
      height: '28px',
      fontSize: '0.8rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    disabled: {
      opacity: 0.6
    },
  };

  // Permissions check function
  const checkPermission = async (categoryHeader) => {
    try {
      const response = await fetch(appConfig.getUrl('/get_user_access_level_new'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          user_id: localStorage.getItem('user_id'),
          project_id: projectId,
          category_header: categoryHeader,
          category_sub_header: []
        }),
      });
      const data = await response.json();
      console.log('API Response:', data);

      const newPermissions = {
        canCreate: false,
        canDelete: false
      };

      data.user_actions_list.forEach(item => {
        switch(item.user_action) {
          case 'Create Links':
            newPermissions.canCreate = item.has_access;
            break;
          case 'Delete Links':
            newPermissions.canDelete = item.has_access;
            break;
        }
      });

      console.log('New Permissions:', newPermissions);
      setPermissions(newPermissions);

      return data.access_status && data.status === 'Success';
    } catch (error) {
      console.error(`Error checking permission for ${categoryHeader}:`, error);
      return false;
    }
  };

  const getSourceId = () => {
    console.log('Selected source IDs: 4', selectedSourceIds);
    console.log('Selected source IDs size: 4', selectedSourceIds.size);

    if (selectedSourceIds.size !== 1) return null;
    return Array.from(selectedSourceIds)[0];
  };

  const resetAllData = () => {
    setLinks([]);
    setSelectedLinks(new Set());
    setError('');
    setSuccessMessage('');
    setIsLoading(false);
    setSearchTerm('');
    setFilteredLinks([]);
    setCurrentPage(1);
  };

  // Sorting functionality
  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  // Apply sorting to links
  const sortedLinks = React.useMemo(() => {
    let sortableLinks = [...filteredLinks];
    if (sortConfig.key) {
      sortableLinks.sort((a, b) => {
        let aVal = a[sortConfig.key] || '';
        let bVal = b[sortConfig.key] || '';

        aVal = aVal.toString().toLowerCase();
        bVal = bVal.toString().toLowerCase();

        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableLinks;
  }, [filteredLinks, sortConfig]);

  // Pagination
  const totalPages = Math.ceil((sortedLinks?.length || 0) / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedLinks = (sortedLinks || []).slice(startIndex, startIndex + itemsPerPage);

  const fetchLinkTypes = async () => {
    setIsLoadingLinkTypes(true);
    try {
      const response = await fetch(appConfig.getUrl('/get_statuses'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          project_id: projectId,
          entity: 'LINK_TYPE',
          search_query: ''
        })
      });

      const data = await response.json();

      if (data.status === 'Success') {
        const linkTypes = data.entity_statuses.map(item => item.status);
        setAvailableLinkTypes(linkTypes);
        if (linkTypes.length > 0) {
          const defaultType = linkTypes.find(type => type === 'IS RELATED TO') || linkTypes[0];
          setSelectedLinkType(defaultType);
        }
      } else {
        console.error('Failed to fetch link types:', data.status_description);
        setAvailableLinkTypes(['IS RELATED TO']);
        setSelectedLinkType('IS RELATED TO');
      }
    } catch (err) {
      console.error('Error fetching link types:', err);
      setAvailableLinkTypes(['IS RELATED TO']);
      setSelectedLinkType('IS RELATED TO');
    } finally {
      setIsLoadingLinkTypes(false);
    }
  };

  useEffect(() => {
    console.log('Selected source IDs: 3', selectedSourceIds);
    console.log('isOpen value: 3', isOpen);
    console.log('getSourceId: 3', getSourceId());
    console.log('SourceIdWithPrefix: 3', sourceIdWithPrefix);
    if (isOpen && getSourceId()) {
      console.log('Selected source IDs: 4', selectedSourceIds);
      resetAllData();
      checkPermission('Manage Links');
      fetchLinks();
      fetchLinkTypes();
      fetchRecordTypes();
    }
  }, [isOpen, selectedSourceIds]);

  useEffect(() => {
    if (searchTerm) {
      const filtered = links.filter(link =>
        link.source_description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        link.target_description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        link.source_id_with_prefix.toLowerCase().includes(searchTerm.toLowerCase()) ||
        link.target_id_with_prefix.toLowerCase().includes(searchTerm.toLowerCase()) ||
        link.project_link_type.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredLinks(filtered);
    } else {
      setFilteredLinks(links);
    }
    setCurrentPage(1);
  }, [searchTerm, links]);

const fetchLinks = async () => {
  const sourceId = getSourceId();
  if (!sourceId) {
    setError('No source Id selected');
    return;
  }

  setIsLoading(true);
  setError('');
  setSelectedLinks(new Set());

    try {
      const response = await fetch(appConfig.getUrl('/get_links_list'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          project_id: projectId,
          source_record_type: sourceRecordType,
          source_id: sourceId,
          search_query: '',
          sort_criteria: ''
        })
      });

      const data = await response.json();

      console.log('Fetched links data 1:', JSON.stringify(data, null, 2));

      if (data.status === 'Success') {
        console.log('Fetched links 2:', data.search_results_list);
        setLinks(data.search_results_list || []);
        setFilteredLinks(data.search_results_list || []);
      } else if (data.status === 'Failed' && data.status_description === 'No matching source results found') {
        setLinks([]);
        setFilteredLinks([]);
      } else {
//        throw new Error(data.status_description || 'Failed to fetch links');
      }
    } catch (err) {
      setError(err.message);
      console.error('Error fetching links:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRecordTypes = async () => {
    setIsLoadingRecordTypes(true);
    try {
      const response = await fetch(appConfig.getUrl('/get_statuses'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          project_id: projectId,
          entity: 'RECORD_TYPE',
          search_query: ''
        })
      });

      const data = await response.json();

      if (data.status === 'Success') {
        const types = data.entity_statuses.map(item => item.status);
        setRecordTypes(types);
      } else {
        console.error('Failed to fetch record types:', data.status_description);
        setRecordTypes([
          'REQUIREMENT', 'USECASE', 'TASK', 'DECISION',
          'ISSUE', 'RISK', 'ACTION', 'QUESTION'
        ]);
      }
    } catch (err) {
      console.error('Error fetching record types:', err);
      setRecordTypes([
        'REQUIREMENT', 'USECASE', 'TASK', 'DECISION',
        'ISSUE', 'RISK', 'ACTION', 'QUESTION'
      ]);
    } finally {
      setIsLoadingRecordTypes(false);
    }
  };

  const searchItems = async () => {
    if (!searchQuery.trim()) {
      setError('Please enter a search term');
      return;
    }

    setIsSearchLoading(true);
    setError('');
    setSearchResults([]);

    try {
      const response = await fetch(appConfig.getUrl('/get_search_results_list'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          project_id: projectId,
          filter_by_status: [],
          search_query: searchQuery,
          sort_criteria: '',
          source_record_type: sourceRecordType,
          source_id: selectedSourceIds.size === 1 ? Array.from(selectedSourceIds)[0] : null,
        })
      });

      const data = await response.json();

      if (data.status === 'Success') {
        if (data.search_results_list && data.search_results_list.length > 0) {
          setSearchResults(data.search_results_list);
        } else {
          setSearchResults([]);
          setError('No search results found. Try a different search term.');
        }
      } else {
        throw new Error(data.status_description || 'Failed to search items');
      }
    } catch (err) {
      setError(err.message);
      console.error('Error searching items:', err);
      setSearchResults([]);
    } finally {
      setIsSearchLoading(false);
    }
  };

  const handleCreateLink = async () => {
    if (selectedTargetIds.length === 0) {
      setError('Please select at least one item to link');
      return;
    }

    if (!selectedLinkType) {
      setError('Please select a link type');
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccessMessage('');

    const sourceId = getSourceId();

    console.log('Selected source ID 1:', sourceId);
    if (!sourceId) {
      console.log('Selected source ID 2:', sourceId);
      setError('No source Id selected');
      setIsLoading(false);
      return;
    }

    try {
      let successCount = 0;
      let hasErrors = false;
      let errorTargetIds = "";
      for (let i = 0; i < selectedTargetIds.length; i++) {
        const compositeKey = selectedTargetIds[i];
        const targetItem = searchResults.find(item =>
          `${item.target_record_type}-${item.target_id}` === compositeKey
        );

        if (!targetItem) {
          console.error(`Target item not found for composite key: ${compositeKey}`);
          setError(`Target item not found for ID: ${compositeKey}`);
          hasErrors = true;
          break;
        }

        const targetId = targetItem.target_id.toString();
        const targetRecordType = targetItem.target_record_type;

        try {
          const response = await fetch(appConfig.getUrl('/create_project_link'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${login_token}`
            },
            body: JSON.stringify({
              corporate_account: corporateAccount,
              project_id: projectId,
              project_link_type: selectedLinkType,
              source_record_type: sourceRecordType,
              source_ids: [sourceId.toString()],
              target_record_type: targetRecordType,
              target_id: targetId
            })
          });

          const data = await response.json();

          if (data.status === 'Success' && data.successful_links) {
            successCount += data.successful_links.length;
            console.log(`Successfully created link for ${targetItem.target_id_with_prefix}`);
          } else {
//            setError(data.status_description || `Failed to create link for ${targetItem.target_id_with_prefix}`);
            errorTargetIds += `${targetItem.target_id_with_prefix}, `;
            console.error(`Failed to create link for ${targetItem.target_id_with_prefix}:`, data.status_description);
            console.error('API error:', data.status_description);
//            hasErrors = true;
//            break;
          }
        } catch (apiError) {
          setError(`API error: ${apiError.message}`);
          console.error('API fetch error:', apiError);
          hasErrors = true;
          break;
        }
      }

        if (successCount > 0) {
          setSuccessMessage(`Successfully created ${successCount} link(s)`);
          await fetchLinks();
          setIsAddLinkDialogOpen(false);
          setSelectedTargetIds([]);
          setSearchQuery('');
          setSearchResults([]);

          setTimeout(() => {
            setSuccessMessage('');
          }, 5000);
        }
        else
           {
              setError(`Failed to create links for target IDs: ${errorTargetIds}`);
              console.error('Link creation errors:', errorTargetIds);
            }

    } catch (err) {
      setError(`Unexpected error: ${err.message}`);
      console.error('Error creating links:', err);
    } finally {
      setIsLoading(false);
    }
  };

  // Delete confirmation dialog handler
  const handleDeleteLinksConfirm = () => {
    if (selectedLinks.size === 0) {
      setError('No links selected for deletion');
      return;
    }
    setIsDeleteConfirmOpen(true);
  };

  // Actual delete function
  const handleDeleteLinks = async () => {
    setIsDeleteConfirmOpen(false);
    setIsLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      const response = await fetch(appConfig.getUrl('/delete_project_links'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          project_id: projectId,
          project_link_ids: Array.from(selectedLinks)
        })
      });

      const data = await response.json();

            if (data.status === 'Success') {
          setSuccessMessage(`Successfully deleted ${selectedLinks.size} link(s)`);
          setSelectedLinks(new Set());
          setSearchResults([]);
          setLinks([]);
          setFilteredLinks([]);

          await fetchLinks();

          setTimeout(() => {
            setSuccessMessage('');
          }, 5000);
        } else {
        throw new Error(data.status_description || 'Failed to delete links');
      }
    } catch (err) {
      setError(err.message);
      console.error('Error deleting links:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddLinkClick = () => {
    setSelectedTargetIds([]);
    setSearchQuery('');
    setSearchResults([]);
    setSelectedRecordType('');
    setSelectedLinkType(availableLinkTypes.length > 0 ?
      (availableLinkTypes.find(type => type === 'IS RELATED TO') || availableLinkTypes[0]) :
      '');
    setError('');
    setSuccessMessage('');
    setIsAddLinkDialogOpen(true);

    if (availableLinkTypes.length === 0) {
      fetchLinkTypes();
    }

    if (recordTypes.length === 0) {
      fetchRecordTypes();
    }
  };

  const toggleSelectAll = () => {
    if (selectedLinks.size === paginatedLinks.length) {
      setSelectedLinks(new Set());
    } else {
      const newSelected = new Set(paginatedLinks.map(link => link.project_link_id));
      setSelectedLinks(newSelected);
    }
  };

  const toggleRowSelection = (linkId) => {
    const newSelected = new Set(selectedLinks);
    if (newSelected.has(linkId)) {
      newSelected.delete(linkId);
    } else {
      newSelected.add(linkId);
    }
    setSelectedLinks(newSelected);
  };

  // Delete confirmation dialog component
  const renderDeleteConfirmDialog = () => {
    if (!isDeleteConfirmOpen) return null;

    return (
      <div style={{...DialogStyles.overlay, zIndex: 1100}}>
        <div style={{...DialogStyles.dialog, width: '500px'}}>
          <div style={{...DialogStyles.title, backgroundColor: '#FFE6E6', color: '#CC0000', padding: '15px 0'}}>
            <div className="flex items-center justify-center gap-2">
              <AlertTriangle size={20} />
              <span>Confirm Deletion</span>
            </div>
          </div>

          <div className="px-6 py-4">
            <p className="text-gray-700 mb-4">
              Are you sure you want to delete {selectedLinks.size} selected link{selectedLinks.size !== 1 ? 's' : ''}?
            </p>
            <p className="text-sm text-red-600 mb-4">
              This action cannot be undone.
            </p>

            {/* Show some details about selected links */}
            <div className="bg-gray-50 rounded p-3 mb-4 max-h-32 overflow-y-auto">
              <p className="text-xs text-gray-600 mb-2">Selected links:</p>
              {Array.from(selectedLinks).slice(0, 5).map(linkId => {
                const link = links.find(l => l.project_link_id === linkId);
                return link ? (
                  <div key={linkId} className="text-xs text-gray-700 mb-1">
                    {link.source_id_with_prefix} → {link.target_id_with_prefix} ({link.project_link_type})
                  </div>
                ) : null;
              })}
              {selectedLinks.size > 5 && (
                <div className="text-xs text-gray-500">
                  ... and {selectedLinks.size - 5} more
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-center gap-4 p-6 pt-0">
            <button
              onClick={() => setIsDeleteConfirmOpen(false)}
              style={{
                backgroundColor: '#f8f9fa',
                padding: '8px 16px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleDeleteLinks}
              style={{
                backgroundColor: '#dc3545',
                color: 'white',
                padding: '8px 16px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Delete {selectedLinks.size} Link{selectedLinks.size !== 1 ? 's' : ''}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderAddLinkDialog = () => {
    if (!isAddLinkDialogOpen) return null;

    return (
      <div style={DialogStyles.overlay}>
        <div style={{...DialogStyles.dialog, width: '1200px'}}>
          <h2 style={{ ...DialogStyles.title, backgroundColor: '#CCCCFF', height: 40   }}>Add Link</h2>

          <div className="mb-6 p-4 border border-gray-300 rounded-md">
            <h3 className="text-base font-semibold mb-3">Adding link to: <strong>{sourceIdWithPrefix || 'No source selected'}</strong></h3>
          </div>

          {/* Search Box */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">
              Search Items:
            </label>
            <div className="flex items-center">
              <input
                ref={searchQueryRef}
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    searchItems();
                  }
                }}
                placeholder="Search for items to link..."
                className="flex-1 p-2 border rounded"
              />
              <button
                onClick={searchItems}
                disabled={isSearchLoading}
                className="ml-2 p-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
              >
                <Search size={16} />
              </button>
            </div>
          </div>

          {/* Link Type Selection */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">
              Link Type: <span className="text-red-500">*</span>
            </label>
            <select
              value={selectedLinkType}
              onChange={(e) => setSelectedLinkType(e.target.value)}
              className="w-full p-2 border rounded"
              disabled={isLoadingLinkTypes}
            >
              {isLoadingLinkTypes ? (
                <option value="">Loading link types...</option>
              ) : availableLinkTypes.length === 0 ? (
                <option value="">No link types available</option>
              ) : (
                availableLinkTypes.map(type => (
                  <option key={type} value={type}>{type}</option>
                ))
              )}
            </select>
            {isLoadingLinkTypes && (
              <p className="text-xs text-gray-500 mt-1">Fetching available link types...</p>
            )}
          </div>

          {/* Search Results */}
          <div className="mb-4">
            <h3 className="text-sm font-medium mb-2">Search Results:</h3>
            <div className="border rounded max-h-60 overflow-y-auto">
              {isSearchLoading ? (
                <div className="p-3 text-center text-gray-500">Loading...</div>
              ) : searchResults.length === 0 ? (
                <div className="p-3 text-center text-gray-500">
                  {searchQuery ? 'No items found. Try a different search.' : 'Enter a search term to find items.'}
                </div>
              ) : (
                <div>
                  {searchResults.map(item => (
                    <div
                      key={`${item.target_record_type}-${item.target_id}`}
                      className={`p-3 border-b hover:bg-gray-50 flex items-center justify-between ${
                        selectedTargetIds.includes(item.target_id.toString()) ? 'bg-blue-50' : ''
                      }`}
                    >
                      <div className="flex-1">
                        <div className="font-medium flex items-center">
                          <span>{item.target_id_with_prefix}</span>
                          <span className="ml-2 px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">
                            {item.target_record_type}
                          </span>
                        </div>
                        <div className="text-sm text-gray-600">{item.target_id_description}</div>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          checked={selectedTargetIds.includes(`${item.target_record_type}-${item.target_id}`)}
                          onChange={() => {
                            const newSelectedIds = [...selectedTargetIds];
                            const compositeKey = `${item.target_record_type}-${item.target_id}`;

                            if (newSelectedIds.includes(compositeKey)) {
                              const index = newSelectedIds.indexOf(compositeKey);
                              newSelectedIds.splice(index, 1);
                            } else {
                              newSelectedIds.push(compositeKey);
                            }
                            setSelectedRecordType(item.target_record_type);
                            setSelectedTargetIds(newSelectedIds);
                          }}
                          className="h-5 w-5"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Error message */}
          {error && (
            <div className="mb-4 p-2 rounded bg-red-50 text-red-500">
              {error}
            </div>
          )}

          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={() => setIsAddLinkDialogOpen(false)}
              style={{
                backgroundColor: '#FFFDD0',
                padding: '8px 16px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
              disabled={isLoading}
            >
              Close
            </button>
            <button
              onClick={handleCreateLink}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleCreateLink();
                }
              }}
              style={{
                padding: '8px 16px',
                backgroundColor: permissions.canCreate ? '#C8F4DE' : '#CCCCCC',
                color: 'black',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
              disabled={isLoading || selectedTargetIds.length === 0 || !selectedLinkType || !permissions.canCreate}
            >
              {isLoading ? 'Creating...' : 'Create Link'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (!isOpen) return null;

  return (
    <div className="min-h-screen bg-gray-50">
      <div style={DialogStyles.overlay}>
<div style={{
  ...DialogStyles.dialog,
  width: '1500px',
  maxHeight: '90vh',
  display: 'flex',
  flexDirection: 'column',
  padding: '0',
  gap: '0',
  margin: '0'
}}>

          {/* Header */}
      <div className="px-6 pt-0 pb-0">
  <div className="flex items-center mb-4 mt-0 justify-between bg-[#CCCCFF] p-3 rounded">
    {/* Search bar */}
    <div className="flex items-center">
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            fetchLinks();
          }
        }}
        placeholder="Search links..."
        className="p-2 pr-10 border rounded w-full"
      />
      <button
        onClick={fetchLinks}
        className="ml-2 p-2 rounded bg-blue-500 hover:bg-blue-600 text-white"
      >
        <Search size={18} />
      </button>
    </div>

    <h1 style={{
      flex: 1,
      textAlign: 'center',
      fontSize: '18px',
      fontWeight: 'bold',
      color: 'black',
      margin: 0
    }}>
      Manage Links - {sourceIdWithPrefix || 'No source selected'}
    </h1>

    {/* Add Link Button with permissions and tooltip */}
    <div className="group relative">
      <button
        className="flex items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        onClick={handleAddLinkClick}
        disabled={!getSourceId() || !permissions.canCreate}
        style={{
          opacity: (!getSourceId() || !permissions.canCreate) ? 0.6 : 1,
          cursor:   'pointer'
        }}
      >
        <Plus size={18} className="mr-2" />
        Add New Link
      </button>

      {/* Hover tooltip for disabled state */}
      {(!getSourceId() || !permissions.canCreate) && (
        <div className="absolute right-0 top-full mt-2 px-3 py-2 bg-gray-600 text-white text-xs rounded shadow-lg invisible group-hover:visible whitespace-nowrap z-20">
          {!getSourceId() ? 'No source selected' : 'Insufficient permission'}
          <div className="absolute bottom-full right-4 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-gray-600"></div>
        </div>
      )}
    </div>
  </div>
</div>

          {/* Error/Success Messages */}
          <div className="px-6">
            {error && (
              <div className={`mb-4 p-2 rounded ${
                error.includes('successfully')
                  ? 'bg-green-50 text-green-700'
                  : 'bg-red-50 text-red-500'
              }`}>
                {error}
              </div>
            )}

            {successMessage && (
              <div className="mb-4 p-2 rounded bg-green-50 text-green-700">
                {successMessage}
              </div>
            )}

            {links.length === 0 && !isLoading && !error && (
              <div className="mb-4 p-2 rounded bg-yellow-50 text-yellow-700">
                No links found for this source Id
              </div>
            )}
          </div>

          {/* Table */}
          <div className="flex-1 overflow-auto px-6">
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.thNonSortable}>
                    <input
                      type="checkbox"
                      checked={paginatedLinks.length > 0 && selectedLinks.size === paginatedLinks.length}
                      onChange={toggleSelectAll}
                      disabled={paginatedLinks.length === 0}
                      style={styles.checkbox}
                    />
                    Select All
                  </th>
                  <th
                    style={styles.th}
                    onClick={() => handleSort('source_id_with_prefix')}
                    className="select-none hover:bg-gray-200 transition-colors"
                  >
                    <div className="flex items-center">
                      <span style={{ textDecoration: 'underline' }}>Source ID</span>
                      <span className="ml-1">
                        {sortConfig.key === 'source_id_with_prefix' ? (
                          sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                        ) : null}
                      </span>
                    </div>
                  </th>
                  <th
                    style={styles.th}
                    onClick={() => handleSort('source_record_type')}
                    className="select-none hover:bg-gray-200 transition-colors"
                  >
                    <div className="flex items-center">
                      <span style={{ textDecoration: 'underline' }}>Source Type</span>
                      <span className="ml-1">
                        {sortConfig.key === 'source_record_type' ? (
                          sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                        ) : null}
                      </span>
                    </div>
                  </th>
                  <th
                    style={styles.th}
                    onClick={() => handleSort('source_description')}
                    className="select-none hover:bg-gray-200 transition-colors"
                  >
                    <div className="flex items-center">
                      <span style={{ textDecoration: 'underline' }}>Source Description</span>
                      <span className="ml-1">
                        {sortConfig.key === 'source_description' ? (
                          sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                        ) : null}
                      </span>
                    </div>
                  </th>
                  <th
                    style={styles.th}
                    onClick={() => handleSort('project_link_type')}
                    className="select-none hover:bg-gray-200 transition-colors"
                  >
                    <div className="flex items-center">
                      <span style={{ textDecoration: 'underline' }}>Link Type</span>
                      <span className="ml-1">
                        {sortConfig.key === 'project_link_type' ? (
                          sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                        ) : null}
                      </span>
                    </div>
                  </th>
                  <th
                    style={styles.th}
                    onClick={() => handleSort('target_id_with_prefix')}
                    className="select-none hover:bg-gray-200 transition-colors"
                  >
                    <div className="flex items-center">
                      <span style={{ textDecoration: 'underline' }}>Target ID</span>
                      <span className="ml-1">
                        {sortConfig.key === 'target_id_with_prefix' ? (
                          sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                        ) : null}
                      </span>
                    </div>
                  </th>
                  <th
                    style={styles.th}
                    onClick={() => handleSort('target_record_type')}
                    className="select-none hover:bg-gray-200 transition-colors"
                  >
                    <div className="flex items-center">
                      <span style={{ textDecoration: 'underline' }}>Target Type</span>
                      <span className="ml-1">
                        {sortConfig.key === 'target_record_type' ? (
                          sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                        ) : null}
                      </span>
                    </div>
                  </th>
                  <th
                    style={styles.th}
                    onClick={() => handleSort('target_description')}
                    className="select-none hover:bg-gray-200 transition-colors"
                  >
                    <div className="flex items-center">
                      <span style={{ textDecoration: 'underline' }}>Target Description</span>
                      <span className="ml-1">
                        {sortConfig.key === 'target_description' ? (
                          sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                        ) : null}
                      </span>
                    </div>
                  </th>
                  <th
                    style={styles.th}
                    onClick={() => handleSort('created_date')}
                    className="select-none hover:bg-gray-200 transition-colors"
                  >
                    <div className="flex items-center">
                      <span style={{ textDecoration: 'underline' }}>Created Date</span>
                      <span className="ml-1">
                        {sortConfig.key === 'created_date' ? (
                          sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                        ) : null}
                      </span>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="9" className="text-center py-8">Loading...</td>
                  </tr>
                ) : paginatedLinks.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center py-8 text-gray-500">
                      No links found. Create a new link or adjust your search.
                    </td>
                  </tr>
                ) : (
                  paginatedLinks.map((link) => (
                    <tr
                      key={link.project_link_id}
                      className="border-t hover:bg-gray-50"
                      style={{
                        backgroundColor: selectedLinks.has(link.project_link_id) ? '#DEEFF5' : 'transparent'
                      }}
                    >
                      <td style={styles.td}>
                        <input
                          type="checkbox"
                          checked={selectedLinks.has(link.project_link_id)}
                          onChange={() => toggleRowSelection(link.project_link_id)}
                          style={styles.checkbox}
                        />
                      </td>
                      <td style={styles.td}>{link.source_id_with_prefix}</td>
                      <td style={styles.td}>
                        <span className="px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800">
                          {link.source_record_type}
                        </span>
                      </td>
                   <td style={styles.td}>
                        <div className="max-w-[200px] break-words" title={link.source_description}>
                          {link.source_description && link.source_description.length > 50
                            ? `${link.source_description.substring(0, 55)}...`
                            : link.source_description}
                        </div>
                      </td>
                      <td style={styles.td}>
                        <span className="px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800 font-medium">
                          {link.project_link_type}
                        </span>
                      </td>
                      <td style={styles.td}>{link.target_id_with_prefix}</td>
                      <td style={styles.td}>
                        <span className="px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">
                          {link.target_record_type}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <div className="max-w-[200px] break-words" title={link.target_description}>
                          {link.target_description && link.target_description.length > 50
                            ? `${link.target_description.substring(0, 55)}...`
                            : link.target_description}
                        </div>
                      </td>
                      <td style={styles.td}>{new Date(link.created_date).toLocaleDateString()}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination controls */}
          {!isLoading && sortedLinks.length > 0 && (
            <div className="mx-6 mt-4 flex justify-between items-center bg-white p-4 rounded-lg shadow">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <span>Total Entries: {sortedLinks.length}</span>
                <span>| Showing {sortedLinks.length > 0 ? startIndex + 1 : 0} - {Math.min(startIndex + itemsPerPage, sortedLinks.length)} of {sortedLinks.length}</span>
              </div>

              <div className="flex items-center gap-2">
                <button
                  className="p-1 rounded hover:bg-gray-200 disabled:opacity-50"
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  aria-label="Previous page"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <span className="text-sm text-blue-600">Page {currentPage} of {Math.max(1, totalPages)}</span>
                <button
                  className="p-1 rounded hover:bg-gray-200 disabled:opacity-50"
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages || totalPages === 0}
                  aria-label="Next page"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>

              <div className="flex items-center">
                <span className="text-sm text-gray-600 mr-2">Items per page:</span>
                <select
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                  className="border rounded p-1 text-sm"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
          )}

          {/* Footer with action buttons and tooltips */}
          <div className="p-6 pt-4 border-t">
            <div className="flex justify-between items-center">
              <div className="flex gap-2">
                <div className="group relative">
                  <button
                    style={{
                      ...styles.deleteButton,
                      padding: '8px 16px',
                      backgroundColor: (isLoading || selectedLinks.size === 0 || !permissions.canDelete) ? '#FF8F89' : '#dc3545',
                      opacity: (isLoading || selectedLinks.size === 0 || !permissions.canDelete) ? 0.6 : 1,
                      cursor:   'pointer'
                    }}
                    onClick={handleDeleteLinksConfirm}
                    disabled={isLoading || selectedLinks.size === 0 || !permissions.canDelete}
                  >
                    {isLoading ? 'Removing...' : `Remove Selected (${selectedLinks.size})`}
                  </button>

                  {/* Delete button tooltip */}
                  {(selectedLinks.size === 0 || !permissions.canDelete) && (
                    <div className="absolute left-0 bottom-full mb-2 px-3 py-2 bg-gray-600 text-white text-xs rounded shadow-lg invisible group-hover:visible whitespace-nowrap z-20">
                      {selectedLinks.size === 0
                        ? "Select one or more links to delete"
                        : "Insufficient permission"
                      }
                      <div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-600"></div>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">
                  {selectedLinks.size > 0 ? `${selectedLinks.size} selected` : ''}
                </span>
                <button
                  style={{
                    backgroundColor: '#FFFDD0',
                    padding: '8px 16px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Add Link Dialog */}
        {renderAddLinkDialog()}

        {/* Delete Confirmation Dialog */}
        {renderDeleteConfirmDialog()}
      </div>
    </div>
  );
};

export default ManageLinksDialog;